<template>
  <resource-create-wrapper
    :title="item ? $t('resources.pages.duplicate_page') : $t('resources.pages.new_page')"
    :need-modal="showModal"
    :show-bottom-actions="true"
    @saveAction="$refs['pageForm'].submit()">
    <PageForm :page="item" @isDirtyForm="isDirtyForm" ref="pageForm" @finishedSaving="finishedSaving"></PageForm>
    <template #actions>
      <v-btn @click="save" outlined color="primary" :loading="saveLoading" class="spacing-right--16">
        {{ $t("generic.buttons.save") }}
      </v-btn>
      <v-btn @click="publish" :loading="publishLoading" color="primary">
        {{ $t("resources.pages.publish") }}
      </v-btn>
    </template>
  </resource-create-wrapper>
</template>

<script>
  import ResourceCreateWrapper from "@/components/resourceWrappers/ResourceCreateWrapper";
  import PageForm from "@/components/forms/PageForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";

  export default {
    components: {
      ResourceCreateWrapper,
      PageForm,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      /**
       * Item is provided here when duplicating
       */
      item: {
        type: Object,
        required: false,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        saveLoading: false,
        publishLoading: false,
      };
    },
    methods: {
      save() {
        this.showModal = false;
        this.saveLoading = true;
        this.$refs["pageForm"].submit(
          this.item
            ? this.$t("resources.pages.duplicated_page_message")
            : this.$t("resources.pages.created_page_message"),
        );
      },
      publish() {
        this.showModal = false;
        this.publishLoading = true;
        this.$refs["pageForm"].changedStatus = 2;
        this.$refs["pageForm"].submit(
          this.$t("resources.pages.published_page_message"),
          this.$t("resources.pages.published_page_message_link_text"),
        );
      },
      finishedSaving() {
        this.publishLoading = false;
        this.saveLoading = false;
      },
    },
  };
</script>
